module.exports = __webpack_public_path__ + "img/mock-event-background-image.9572ef9a.jpg";